import createPersistedState from 'vuex-persistedstate';
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import products from './products';
import cart from './cart';
import history from './history';
import supplier from './suppliers';
import shopAuth from './shopAuth';
import bakeryAuthService from './bakery-auth-service';
import settings from './settings';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    products,
    cart,
    history,
    bakeryAuthService,
    settings,
    supplier,
    shopAuth,
  },
  plugins: [createPersistedState()],
});
